const CALENDLY_SCRIPT_ID = "calendly-widget-script";
const CALENDLY_STYLE_ID = "calendly-widget-style";
const SCRIPT_URL = "https://assets.calendly.com/assets/external/widget.js";
const STYLE_URL = "https://calendly.com/assets/external/widget.css";

let calendlyPromise;

export function loadCalendly() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.reject(new Error("Calendly can only load in a browser."));
  }
  if (window.Calendly) return Promise.resolve(window.Calendly);
  if (calendlyPromise) return calendlyPromise;

  if (!document.getElementById(CALENDLY_STYLE_ID)) {
    const link = document.createElement("link");
    link.id = CALENDLY_STYLE_ID;
    link.rel = "stylesheet";
    link.href = STYLE_URL;
    document.head.appendChild(link);
  }

  calendlyPromise = new Promise((resolve, reject) => {
    let script = document.getElementById(CALENDLY_SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = CALENDLY_SCRIPT_ID;
      script.src = SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", () => {
      if (window.Calendly) resolve(window.Calendly);
      else reject(new Error("Calendly loaded without exposing window.Calendly"));
    }, { once: true });
    script.addEventListener("error", () => {
      calendlyPromise = undefined;
      reject(new Error("Unable to load Calendly widget.js"));
    }, { once: true });
  });

  return calendlyPromise;
}
